import styled from 'styled-components';

export const AnswerModalContainer = styled.div`
  width: 100%;
`;

export const AnswerModalContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background-color: #F5F5F5;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 8px;
  border: 1px solid #E6E6E6;
`;

export const AnswerModalTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;

export const AnswerModalTitle = styled.h2`
  font-size: 12px;
  font-weight: 600;
  max-height: 40px;
`;

export const AnswerModalText = styled.p`
  font-size: 10px;
`;

export const AnswerModalButton = styled.div`
  cursor: pointer;
`;